export const CSS_CLASSES = {
  /* Main Nav Menu */
  MAIN_NAV_MENU_ROOT: "main-nav-menu",
  MAIN_NAV_MENU_VERTICAL: "main-nav-menu-vertical",
  MAIN_NAV_MENU_HORIZONTAL: "main-nav-menu-horizontal",
  MAIN_NAV_MENU_INTERACTIVE: "main-nav-menu-interactive",
  MAIN_NAV_MENU_PRIMARY: "main-nav-menu-primary",
  MAIN_NAV_MENU_WHITE: "main-nav-menu-white",
  MAIN_NAV_MENU_OPEN_ON_HOVER: "main-nav-menu-open-on-hover",
  MAIN_NAV_MENU_OPEN_ON_CLICK: "main-nav-menu-open-on-click",
  MAIN_NAV_MENU_LIST: "main-nav-menu-list",
  MAIN_NAV_MENU_ITEM: "main-nav-menu-item",
  MAIN_NAV_MENU_ITEM_ACTIVE: "main-nav-menu-item-active",
  MAIN_NAV_MENU_ITEM_EXPANDED: "main-nav-menu-item-expanded",
  MAIN_NAV_MENU_ITEM_LINK_WRAPPER: "main-nav-menu-item-link-wrapper",
  MAIN_NAV_MENU_ITEM_LINK: "main-nav-menu-item-link",
  MAIN_NAV_MENU_ITEM_LINK_LABEL: "main-nav-menu-item-link-label",
  MAIN_NAV_MENU_ITEM_EXPAND_COLLAPSE_ICON: "main-nav-menu-item-expand-collapse-icon",
  MAIN_NAV_MENU_ITEM_EXPAND_COLLAPSE_BUTTON: "main-nav-menu-item-expand-collapse-button",

  /* Horizontal Main Nav Menu */
  HORIZONTAL_MAIN_NAV_MENU_ROOT: "horizontal-main-nav-menu",
  HORIZONTAL_MAIN_NAV_MENU_COLOR_INTERACTIVE: "horizontal-main-nav-color-interactive",
  HORIZONTAL_MAIN_NAV_MENU_COLOR_PRIMARY: "horizontal-main-nav-color-primary",
  HORIZONTAL_MAIN_NAV_MENU_OPEN_ON_CLICK: "horizontal-main-nav-menu-open-on-click",
  HORIZONTAL_MAIN_NAV_MENU_OPEN_ON_HOVER: "horizontal-main-nav-menu-open-on-hover",
  HORIZONTAL_MAIN_NAV_MENU_LIST: "horizontal-main-nav-menu-list",
  HORIZONTAL_MAIN_NAV_MENU_ITEM: "horizontal-main-nav-menu-item",
  HORIZONTAL_MAIN_NAV_MENU_ITEM_LINK: "horizontal-main-nav-menu-item-link",
  HORIZONTAL_MAIN_NAV_MENU_ITEM_LINK_LIGHT: "horizontal-main-nav-menu-item-link-light",
  HORIZONTAL_MAIN_NAV_MENU_ITEM_LINK_DARK: "horizontal-main-nav-menu-item-link-dark",
  HORIZONTAL_MAIN_NAV_MENU_ITEM_LINK_LABEL: "horizontal-main-nav-menu-item-link-label",
  HORIZONTAL_MAIN_NAV_MENU_ITEM_LINK_LABEL_ACTIVE: "horizontal-main-nav-menu-item-link-label-active",
  HORIZONTAL_MAIN_NAV_MENU_SUB_ITEM_LINK_LABEL_ACTIVE: "horizontal-main-nav-menu-sub-item-link-label-active",
  HORIZONTAL_MAIN_NAV_MENU_ITEM_LINK_LABEL_ICON: "horizontal-main-nav-menu-item-link-label-icon",

  /* Vertical Main Nav Menu */
  VERTICAL_MAIN_NAV_MENU: "global-header-mobile-nav-main-menu",
  VERTICAL_MAIN_NAV_MENU_SUB_ITEMS: "global-header-mobile-nav-main-menu-sub-items",
  VERTICAL_MAIN_NAV_MENU_SUB_ITEMS_COLOR_INTERACTIVE: "global-header-mobile-nav-main-menu-sub-items-color-interactive",
  VERTICAL_MAIN_NAV_MENU_SUB_ITEMS_COLOR_PRIMARY: "global-header-mobile-nav-main-menu-sub-items-color-primary",
  VERTICAL_MAIN_NAV_MENU_ITEM_ROOT: "global-header-mobile-nav-main-menu-item",
  VERTICAL_MAIN_NAV_MENU_ITEM_COLOR_INTERACTIVE: "global-header-mobile-nav-main-menu-item-color-interactive",
  VERTICAL_MAIN_NAV_MENU_ITEM_COLOR_PRIMARY: "global-header-mobile-nav-main-menu-item-color-primary",
  VERTICAL_MAIN_NAV_MENU_ITEM_LABEL: "global-header-mobile-nav-main-menu-item-label",
  VERTICAL_MAIN_NAV_MENU_ITEM_LABEL_ACTIVE: "global-header-mobile-nav-main-menu-item-label-active",
  VERTICAL_MAIN_NAV_MENU_ITEM_LABEL_ICON: "global-header-mobile-nav-main-menu-item-label-icon",
  VERTICAL_MAIN_NAV_MENU_SUB_ITEM_ROOT: "global-header-mobile-nav-main-menu-sub-item",
  VERTICAL_MAIN_NAV_MENU_SUB_ITEM_LABEL: "global-header-mobile-nav-main-menu-sub-item-label",
  VERTICAL_MAIN_NAV_MENU_SUB_ITEM_LABEL_ACTIVE: "global-header-mobile-nav-main-menu-sub-item-label-active",

  /* Section Nav Menu */
  SECTION_NAV_MENU: "section-nav-menu",
  SECTION_NAV_MENU_STICKY: "section-nav-menu-sticky",
  SECTION_NAV_MENU_COLOR_INTERACTIVE: "section-nav-menu-color-interactive",
  SECTION_NAV_MENU_COLOR_PRIMARY: "section-nav-menu-color-primary",

  /* Horizontal Section Nav Menu */
  HORIZONTAL_SECTION_NAV_MENU_LIST: "horizontal-section-nav-menu-list",
  HORIZONTAL_SECTION_NAV_MENU_ITEM: "horizontal-section-nav-menu-item",
  HORIZONTAL_SECTION_NAV_MENU_ITEM_LINK: "horizontal-section-nav-menu-item-link",
  HORIZONTAL_SECTION_NAV_MENU_ITEM_LINK_ACTIVE: "horizontal-section-nav-menu-item-link-active",

  /* Vertical Section Nav Menu */
  VERTICAL_SECTION_NAV_MENU_LIST: "vertical-section-nav-menu-list",
  VERTICAL_SECTION_NAV_MENU_ITEM: "vertical-section-nav-menu-item",
  VERTICAL_SECTION_NAV_MENU_ITEM_LINK: "vertical-section-nav-menu-item-link",
  VERTICAL_SECTION_NAV_MENU_ITEM_LINK_ACTIVE: "vertical-section-nav-menu-item-link-active",
  VERTICAL_SECTION_NAV_MENU_ITEM_LINK_TEXT: "vertical-section-nav-menu-item-text",
  VERTICAL_SECTION_NAV_MENU_ITEM_LINK_TEXT_COLLAPSIBLE: "vertical-section-nav-menu-item-text-collapsible",
  VERTICAL_SECTION_NAV_MENU_ITEM_LINK_ICON: "vertical-section-nav-menu-item-icon",

  /* Mobile Section Nav Menu */
  MOBILE_SECTION_NAV_MENU: "mobile-section-nav-menu",
  MOBILE_SECTION_NAV_MENU_CLOSED: "mobile-section-nav-menu-closed",
  MOBILE_SECTION_NAV_MENU_OPEN: "mobile-section-nav-menu-open",
  MOBILE_SECTION_NAV_MENU_LIST: "mobile-section-nav-menu-list",
  MOBILE_SECTION_NAV_MENU_LIST_VISIBLE: "mobile-section-nav-menu-list-visible",
  MOBILE_SECTION_NAV_MENU_CLOSE_BUTTON: "mobile-section-nav-menu-close-button",
};
